export default {
    sentryDSN:
        'https://e774eed4149da1089b49939ba7323bb6@o4507050262921216.ingest.us.sentry.io/4507390055219200', // https://vimeo.com/899367471
}
